/** Rule points whose evidence and remaining uncertainty are recorded in MECHANICS_SOURCES.md. */
export const RULES = Object.freeze({
 tickMs:600, jadPeriod:9, jadOffsets:[2,5,8] as readonly number[],
 jadSnapshotDelay:3, jadImpactAfterSnapshot:1, healerThreshold:175,
 healerCount:3, healerPeriod:4, healerMin:15, healerMax:24,
 healerDespawnWithOwner:true, meleeChanceAtProximity:0.5,
 // Ground walking underneath NPCs is legal in OSRS; interaction routes stop outside.
 playerCanWalkUnderNpcs:true,
 stallLimitMs:250, npcRange:50,
});
/** InfernoTrainer beta's southwest anchors, with +y pointing south. */
export const ARENA = Object.freeze({minX:11,maxX:39,minY:14,maxY:43,width:51,height:57,
 jads:[{x:18,y:24},{x:28,y:24},{x:23,y:35}], player:{x:25,y:27},
 rubble:[{x:27,y:19,size:3},{x:17,y:28,size:3},{x:27,y:37,size:3}]
});
